import axios from 'axios';
import {backendHost} from '../../../../store/config';

const getViewMessanger = (params) => {
    return axios.get(`${backendHost}/api/admin/messanger/${params.id}`);
};

export {
    getViewMessanger
}